import PropTypes from "prop-types";
// @mui
import {
  Box,
  Checkbox,
  TableRow,
  TableCell,
  TableHead,
  TableSortLabel,
} from "@mui/material";

// ----------------------------------------------------------------------

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: "1px",
  height: "1px",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  clip: "rect(0 0 0 0)",
};

// ----------------------------------------------------------------------

TableHeadCustom.propTypes = {
  sx: PropTypes.object,
  onSort: PropTypes.func,
  orderBy: PropTypes.string,
  headLabel: PropTypes.array,
  rowCount: PropTypes.number,
  numSelected: PropTypes.number,
  onSelectAllRows: PropTypes.bool,
  order: PropTypes.oneOf(["asc", "desc"]),
};

export default function TableHeadCustom({
  order,
  orderBy,
  rowCount = 0,
  headLabel,
  numSelected = 0,
  onSort,
  onSelectAllRows,
  isClassicalView,
  sx,
}) {
  return (
    <TableHead 
      sx={{
        ...sx,
        ...(isClassicalView && {
          "& .MuiTableCell-root": {
            py: 0.5,
            px: 1,
            height: 34,
            fontSize: 12,
            fontWeight: 600,
            whiteSpace: "nowrap",
          },
        }),
  }}>
      <TableRow>
        {onSelectAllRows && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={(event) => onSelectAllRows(event.target.checked)}
            />
          </TableCell>
        )}

        {headLabel.map((headCell, index) => (
          <TableCell
            key={`${headCell.id}${index}`}
            align={headCell.align || "left"}
            sortDirection={orderBy === headCell.id ? order : false}
            // sx={{ width: headCell.width, minWidth: headCell.minWidth }}
            sx={{ width: headCell.width, minWidth: headCell.minWidth, ...(isClassicalView && { py: 0.5,px: 1,})}}>
            {onSort ? (
              <TableSortLabel
                hideSortIcon
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={() => onSort(headCell.id)}
                // sx={{ textTransform: "capitalize" }}
                sx={{ textTransform: "capitalize", ...(isClassicalView && { fontSize: 12, lineHeight: 1.2})}}>
                {headCell.label}

                {orderBy === headCell.id ? (
                  <Box sx={{ ...visuallyHidden }}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
